module.exports = "<div class=\"sc-content-inside\">     \n  \n   <router-outlet></router-outlet>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/content/content.component.html
// module id = ../../../../../src/app/dashboard/content/content.component.html
// module chunks = main